<template>
  <div class="ac-transition">
    <div class="card print-hide">
      <button @click="printReceipt" class="btn b-light btn-danger-light btn-sm">
        Print Receipt
      </button>
    </div>
    
       <div id="receipt" class="receipt">
      <div class="receipt-header" style="padding-top: 100px;">
        <!--<h1 class="business-name">{{setting[1]?.settingvalue}}</h1>-->
        <!--<p class="business-info">{{setting[2]?.settingvalue}}</p>-->
        <!--<p class="business-contact">📞 {{setting[3]?.settingvalue}}</p>-->
        <!--<div class="header-divider"</div>-->
      </div>
      
      <!--<div class="receipt-details">-->
      <!--  <div class="detail-row">-->
      <!--    <span class="detail-label">Invoice No:</span>-->
      <!--    <span class="detail-value1">{{invDetails.id}}</span>-->
      <!--  </div>-->
      <!--  <div class="detail-row">-->
      <!--    <span class="detail-label">Date:</span>-->
      <!--    <span class="detail-value1">{{invDetails.entry_date}}</span>-->
      <!--  </div>-->
      <!--  <div class="detail-row">-->
      <!--    <span class="detail-label">Customer:</span>-->
      <!--    <span class="detail-value1">{{customer.name}}</span>-->
      <!--  </div>-->
      <!--</div>-->
      
      <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse;width: 100%; ">
           
                <tr>
                    <td><b>Invoice No:</b>   &nbsp;  {{invDetails.id}}</td>
                  
                    <td><b>Date:</b>   &nbsp; {{ formatDate(invDetails.entry_date) }}</td>
                    
                </tr>
                <!--<tr>-->
                <!--    <td><b>Date:</b></td>-->
                <!--    <td>{{invDetails.entry_date}}</td>-->
                <!--</tr>-->
                <tr>
                    <td><b>Customer:</b>  &nbsp;  &nbsp;{{customer.name}}</td>
                   <td><b v-if="invDetails.delivery && invDetails.delivery!='0000-00-00'">Delivery:</b>  &nbsp;  &nbsp;{{invDetails.delivery && invDetails.delivery!='0000-00-00' ?invDetails.delivery: ''}}</td>
                </tr> 
        </table>
      
      
      <table class="items-table">
        <thead>
          <tr class="table-header">
            <th class="text-center">#</th>
            <th class="text-left">Barcode</th>
            <th class="text-left">Product</th>
            <!--<th class="text-left">Delivery Date</th>-->
            <th class="text-center">Qty</th>
            <th class="text-right">Rate</th>
            <th class="text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in order_items" :key="item.id" class="table-row">
            <td class="text-center">{{ index+1 }}</td>
            <td class="text-center">{{item.barcode}}</td>
            <td>{{ item.cat_name? item.cat_name :( item.stich_name || item.prd_name )}}
            <!--<br><i>{{ item.deliverydate === '0000-00-00' ? '--' : item.deliverydate }}</i>  -->
            
            </td>
            <!--<td>{{ item.deliverydate === '0000-00-00' ? '--' : item.deliverydate }}</td>-->
            <!--<td class="text-center">{{ Math.abs(item.pieceqty) }} ({{item.meterqty}})</td>-->
            <td class="text-center">{{ Math.abs(item.pieceqty) }} </td>
            <!--<td class="text-right">{{ formatCurrency((item.rate *   Math.abs(item.pieceqty)) }}</td>-->
            <!--<td class="text-right">{{ formatCurrency(item.rate * Math.abs(item.qty)) }}</td>-->
                       <td class="text-right">{{ formatCurrency((item.rate)) }}</td>
            <td class="text-right">{{ formatCurrency(item.rate * Math.abs(item.pieceqty)) }}</td>
          </tr>
        </tbody>
      </table>
      
      <div class=" -summary">
          <div class="w-full max-w-md ml-auto mt-1 text-sm">
          <!-- ऍडव्हान्स -->
          <div class="flex justify-between border-b border-gray-300" v-if="invDetails.washing_qty">
              <span></span>
              <span></span>
              <span></span>
            <span class="font-medium  text-xs text-dark-700">वॉशिंग: {{parseInt(invDetails.washing_qty) +"x"+ parseInt(invDetails.washing_rate)}}</span>
            <span class="font-semibold  text-xs text-gray-800">{{ parseInt(invDetails.washing_total) }}</span>
          </div>
          
          <!-- एकूण रु. -->
          <div class="flex justify-between border-b border-gray-300 ">
              <span></span>
              <span></span>
              <span></span>
            <span class="font-medium  text-xs text-dark-700">एकूण रु.:</span>
            <span class="font-semibold text-xs  text-gray-800">{{ formatCurrency(invDetails.total) }}</span>
          </div>
          <div class="flex justify-between border-b border-gray-300">
              <span></span>
              <span></span>
              <span></span>
            <span class="font-medium text-xs  text-dark-700">अँडव्हान्स:</span>
            <span class="font-semibold text-xs  text-gray-800">{{ formatCurrency(invDetails.paid) }}</span>
          </div>
        
        
          <!-- येणेबाकी -->
          <div class="flex justify-between ">
              <span></span>
              <span></span>
              <span></span>
            <span class="font-medium text-xs  text-dark-700">येणेबाकी:</span>
            <span class="font-bold text-xs  text-red-600">{{ parseInt(invDetails.total || 0 )- parseInt(invDetails.paid || 0) }}</span>
          </div>
        </div>
            
            
             <div v-if="invDetails.ismeasurement && invDetails.washing" class="delivery-info">
              <strong>वॊशिंग:</strong> {{ invDetails.washing }}
            </div> 
         <div v-if="qrCodeDataUrl">
          <!--<h3>Scan to Pay</h3>-->
         
        </div>
<!--        <p style="-->
<!--    font-size: x-small;-->
<!--">टिप :<br>-->
<!--१. ९०% ऍडव्हान्स दिल्याशिवाय कपडे शिलाई होणार नाही.<br>-->
<!--२. दिलेल्या मापानुसार कपडे मिळेल व नंतर तक्रार चालणार नाही.<br>-->
<!--३. कपडे तयार झाल्यावर १५ दिवसाच्या आत कपडे न नेल्यास कपडे हरविल्यास ऍडव्हान्स व कपडे परत मिळणार नाही.<br>-->
<!--४. कुठल्याही कपड्याची व कलरची गॅरंटी नाही.<br>-->
<!--६. पावती शिवाय कपडे मिळणार नाही.<br>-->
<!--७. दुकानाची वेळ सकाळी १० ते सायं.९ पर्यंत</p>-->
      </div>
      
      <div class="receipt-footer">
        <img style="
   position: absolute;bottom: 15px;width: 100px;left: 15px;
"  :src="qrCodeDataUrl" alt="UPI QR Code" />
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import QRCode from "qrcode";

export default {
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
      receiptNumber: '',
      customer:[],
      invDetails:[],
      order_items:[], 
      setting:[],
      upidata:[],
      qrCodeDataUrl:''
       
    };
  },
  computed: {
    totalAmount() {
      return this.items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
    },
  },
  mounted() { 
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
       formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    //  async getBasics(invoiceid) {
    //       var self=this;
    //         async axios.post('getInvoice',{invoiceid:invoiceid}).then(function (response) {
    //                      self.order_items=response.data.order_items;
    //                      self.employees=response.data.userDetails;
    //                      self.invDetails=response.data.invDetails;
    //                      self.customer=response.data.customer;
    //                      self.setting=response.data.setting;
    //                      self.upidata=response.data.upidata;
    //                     try {
    //                         document.getElementById("loader").remove();  
    //                         // sel.printReceipt();
    //                     } catch (e) {}
    //                 }).then(()=>{ 
                        
    //                      const upiUrl = `upi://pay?pa=${encodeURIComponent( self.upidata.upiId)}&pn=${encodeURIComponent( self.upidata.payeeName)}&am=${encodeURIComponent( self.upidataamount)}&cu=INR`
    //                     try {
    //                         self.qrCodeDataUrl.value = await QRCode.toDataURL(upiUrl)
    //                       } catch (err) {
    //                         console.error('Error generating QR code:', err)
    //                       }
                           
    //                      self.printReceipt();
                         
                         
                         
                  
    //                     });;
    //   },
      async getBasics(invoiceid) {
          const self = this;
        
          try {
            // ✅ Await the axios call — no "async" before axios.post!
            const response = await axios.post('getInvoice', { invoiceid });
        
            self.order_items = response.data.order_items;
            self.employees = response.data.userDetails;
            self.invDetails = response.data.invDetails;
            self.customer = response.data.customer;
            self.setting = response.data.setting;
            self.upidata = response.data.upidata;
        
            // Remove loader safely
            try {
              document.getElementById("loader")?.remove();
            } catch (e) {
              console.warn("Loader not found or already removed");
            }
        
            const amount = parseFloat(self.upidata.amount || 0).toFixed(2);

            const upiUrl = `upi://pay?pa=q000784272@ybl&pn=${encodeURIComponent("SAMARTH TAILORING AND CUTPIECE")}&am=${encodeURIComponent(amount)}&cu=INR`;
        
            // ✅ Generate QR Code
            try {
              self.qrCodeDataUrl = await QRCode.toDataURL(upiUrl);
            } catch (err) {
              console.error("QR Code generation error:", err);
            }
        
            // ✅ Call the print function
             self.$nextTick(() => {
              self.printReceipt();
            });
        
          } catch (err) {
            console.error("Error fetching invoice data:", err);
          }
        },
      
    formatCurrency(value) {
      return value;//`$${value.toFixed(2)}`;
    },
    printReceipt() {
      window.print();
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@200;500&display=swap');

/* Base styles */
.receipt {
  font-family: 'Arial', sans-serif;
  width: 148mm; /* A5 width */
  min-height: 210mm; /* A5 height */
  margin: 0 auto;
  padding: 15mm;
  color: #000;
  box-sizing: border-box;
}

.print-hide {
  margin-bottom: 20px;
}

/* Header styles */
.receipt-header {
  text-align: center;
  margin-bottom: 15px;
}

.business-name {
  font-size: 24px;
  font-weight: bold;
  margin: 10px 0;
}

.business-info, .business-contact {
  font-size: 14px;
  margin: 5px 0;
}

.header-divider {
  border-top: 2px dashed #000;
  margin: 15px 0;
}

/* Details section */
.receipt-details {
  margin-bottom: 15px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 14px;
}

.detail-label {
  font-weight: bold;
}

/* Items table */
.items-table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
  font-size: 14px;
  border: 1px solid #333;
}

.items-table th, .items-table td {
  padding: 2px 4px;
  border: 1px solid #333;
}

.table-header {
  background-color: #f5f5f5;
  font-weight: bold;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

/* Summary section */
.receipt-summary {
  margin-top: 20px;
  font-size: 15px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.total-row {
  font-weight: bold;
  font-size: 14px;
  border-top: 2px solid #333;
  padding-top: 5px;
}

.delivery-info {
  margin-top: 15px;
  text-align: center;
  font-size: 14px;
  padding: 8px;
  border: 1px dashed #333;
  background-color: #f8f8f8;
}

/* Footer */
.receipt-footer {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  padding-top: 15px;
  border-top: 1px dashed #333;
}

.thank-you {
  font-style: italic;
}

/* Print-specific styles */
@media print {
  @page {
    size: A5;
    margin: 0;
  }
  
  body {
    margin: 0;
    padding: 0;
    background: #fff;
    width: 148mm;
    height: 210mm;
  }
  
  button, .print-hide {
    display: none;
  }
  
  .receipt {
    width: 148mm;
    min-height: 210mm;
    padding: 15mm;
    margin: 0;
    border: none;
  }
  
  .items-table,
  .items-table th, 
  .items-table td {
    border: 1px solid #000 !important;
  }
  
  .total-row {
    border-top: 2px solid #000 !important;
  }
  
  .receipt-footer {
    border-top: 1px dashed #000 !important;
  }
}

/* Devanagari font classes */
.dn_f { 
  font-family: 'Noto Sans Devanagari', sans-serif;
  font-size: 16px;
}

.dn_f_only { 
  font-family: 'Noto Sans Devanagari', sans-serif;
}

@media print {
  .dn_f_only {
    font-size: 18px;
    font-weight: 800;
  }
  
  .dn_f {
    font-size: 16px;
  }
}
</style>